"use client";
import React from "react";

interface TipCardProps {
  imageUrl: string;
  badgeText: string;
  description: string;
}

const TipCard: React.FC<TipCardProps> = ({
  imageUrl,
  badgeText,
  description,
}) => {
  return (
    <article className="flex flex-col justify-center p-5 mt-6 w-full text-sm bg-white rounded-xl border border-solid shadow-sm border-[color:var(--Colors-Border-border-secondary,#EAECF0)] min-w-[216px]">
      <div className="flex gap-6 items-center w-full">
        <img
          src={imageUrl}
          alt={badgeText}
          className="object-contain shrink-0 self-stretch my-auto w-14 rounded-xl aspect-square"
        />
        <div className="flex-1 shrink self-stretch my-auto basis-0">
          <div className="w-full">
            <div className="w-full">
              <div className="flex gap-1 items-start w-full font-medium leading-none text-center text-blue-700">
                <span className="gap-1 self-stretch py-0.5 pr-2.5 pl-2 bg-sky-50 rounded-full border border-sky-200 border-solid">
                  {badgeText}
                </span>
              </div>
              <p className="gap-1 mt-3 w-full leading-5 text-black">
                {description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default TipCard;
